var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _circle, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "46px",
    viewBox: "0 0 23 46",
    enableBackground: "new 0 0 23 46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M20.038,32.932c0.296,0.228,0.478,0.58,0.478,1.004v5.668c0,0.377-0.148,0.727-0.438,0.971 c-0.069,0.059-0.139,0.105-0.207,0.145v0.02c-0.008,0.361-0.073,0.715-0.195,1.055c-1.073,2.961-5.852,3.65-8.543,3.656 c-2.695,0.005-7.455-0.664-8.552-3.615c-0.131-0.353-0.2-0.722-0.207-1.097l-0.001-0.025c-0.387-0.208-0.644-0.589-0.644-1.108 v-5.668c0-0.396,0.165-0.763,0.478-1.004L1.877,17.514l-1.43,0.383l-0.301-0.864c-0.423-1.214,0.102-2.008,1.167-2.417 c-0.029-0.11-0.045-0.228-0.045-0.352V8.595c0-0.404,0.153-0.72,0.398-0.938L1.651,6.95C1.639,6.352,1.896,5.715,2.184,5.173 C2.261,4.352,2.886,3.417,3.332,2.84c0.498-0.646,1.357-1.611,2.27-1.754C6.128,0.688,6.759,0.333,7.41,0.333h7.424 c0.655,0,1.29,0.359,1.817,0.759c0.897,0.156,1.761,1.102,2.261,1.739c0.461,0.588,1.074,1.518,1.147,2.34 c0.288,0.542,0.546,1.18,0.534,1.778l-0.016,0.707c0.245,0.217,0.398,0.534,0.398,0.938v5.669c0,0.119-0.016,0.236-0.045,0.347 c0.43,0.163,0.822,0.401,1.077,0.815c0.291,0.473,0.294,1.017,0.116,1.531l-0.328,0.94l-1.43-0.383L20.038,32.932z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E8E9",
    d: "M19.872,33.015c0.296,0.194,0.479,0.519,0.479,0.921v5.668c0,0.327-0.127,0.633-0.379,0.846 c-0.088,0.073-0.176,0.127-0.264,0.167l-0.002,0.118c-0.008,0.343-0.069,0.68-0.187,1.002c-1.042,2.878-5.78,3.543-8.389,3.548 c-2.613,0.005-7.331-0.64-8.397-3.507c-0.125-0.336-0.19-0.688-0.197-1.043l-0.002-0.126c-0.382-0.169-0.642-0.513-0.642-1.005 v-5.668c0-0.362,0.155-0.693,0.453-0.904c0.009-0.006,0.018-0.012,0.026-0.018L2.037,17.301l-1.485,0.397l-0.25-0.72 c-0.412-1.184,0.139-1.902,1.219-2.263c-0.057-0.134-0.087-0.286-0.087-0.452V8.595c0-0.385,0.155-0.674,0.4-0.862L1.816,6.947 C1.803,6.37,2.065,5.744,2.344,5.221c0.059-0.79,0.693-1.731,1.118-2.281C3.93,2.333,4.788,1.354,5.667,1.243 C6.17,0.857,6.787,0.497,7.41,0.497h7.424c0.627,0,1.246,0.363,1.751,0.751c0.862,0.124,1.727,1.083,2.198,1.685 c0.44,0.562,1.063,1.496,1.116,2.286c0.28,0.523,0.542,1.15,0.53,1.728l-0.018,0.786c0.244,0.188,0.4,0.477,0.4,0.862v5.669 c0,0.157-0.029,0.309-0.088,0.448c0.455,0.152,0.883,0.376,1.145,0.8c0.266,0.43,0.263,0.924,0.102,1.391l-0.277,0.796l-1.485-0.397 L19.872,33.015z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDE0E0",
    d: "M19.706,33.106c0.295,0.157,0.481,0.451,0.481,0.829v5.668c0,0.279-0.105,0.538-0.321,0.72 c-0.105,0.089-0.211,0.145-0.318,0.179l-0.005,0.229c-0.007,0.325-0.066,0.645-0.177,0.95c-0.493,1.36-1.89,2.174-3.181,2.642 c-1.572,0.57-3.387,0.794-5.054,0.798c-1.665,0.003-3.476-0.212-5.049-0.774c-1.293-0.463-2.69-1.27-3.195-2.626 C2.77,41.4,2.708,41.068,2.702,40.73l-0.005-0.235c-0.376-0.126-0.639-0.428-0.639-0.892v-5.669c0-0.308,0.128-0.59,0.383-0.769 c0.033-0.023,0.065-0.043,0.098-0.061L2.196,17.088L0.657,17.5l-0.2-0.576C0.309,16.5,0.261,16.05,0.484,15.641 c0.246-0.449,0.718-0.659,1.185-0.8c0.031-0.01,0.061-0.019,0.092-0.028c-0.104-0.148-0.164-0.334-0.164-0.55V8.595 c0-0.364,0.158-0.623,0.401-0.778L1.98,6.943C1.968,6.388,2.234,5.771,2.506,5.268C2.543,4.514,3.19,3.561,3.592,3.04 C4.028,2.475,4.891,1.476,5.73,1.401c0.48-0.374,1.084-0.74,1.68-0.74h7.423c0.596,0,1.199,0.366,1.68,0.739 c0.5,0.044,0.974,0.419,1.321,0.743c0.29,0.269,0.575,0.58,0.818,0.891c0.419,0.535,1.052,1.476,1.085,2.231 c0.271,0.503,0.539,1.122,0.527,1.678l-0.02,0.874c0.244,0.155,0.402,0.414,0.402,0.778v5.668c0,0.199-0.055,0.388-0.162,0.545 c0.484,0.141,0.971,0.348,1.243,0.79c0.239,0.388,0.231,0.832,0.085,1.251L21.588,17.5l-1.539-0.412L19.706,33.106z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D7D7",
    d: "M19.539,33.211c0.295,0.114,0.484,0.372,0.484,0.725v5.668c0,0.23-0.085,0.445-0.264,0.595 c-0.12,0.102-0.244,0.151-0.373,0.176l-0.008,0.354c-0.007,0.308-0.063,0.608-0.167,0.897c-0.475,1.311-1.842,2.094-3.082,2.543 c-1.555,0.564-3.351,0.785-4.999,0.789c-1.646,0.003-3.438-0.21-4.993-0.766c-1.243-0.445-2.611-1.223-3.097-2.528 c-0.112-0.302-0.17-0.616-0.176-0.937l-0.007-0.355c-0.367-0.08-0.637-0.333-0.637-0.768v-5.668c0-0.254,0.103-0.486,0.313-0.635 c0.057-0.039,0.113-0.069,0.17-0.092L2.356,16.876l-1.595,0.427l-0.15-0.432c-0.131-0.378-0.183-0.785,0.017-1.15 c0.222-0.406,0.667-0.595,1.088-0.723c0.119-0.036,0.239-0.069,0.36-0.1c-0.195-0.135-0.314-0.351-0.314-0.634V8.595 c0-0.342,0.163-0.565,0.403-0.685L2.144,6.94C2.132,6.406,2.404,5.795,2.667,5.313C2.68,4.602,3.343,3.631,3.722,3.14 c0.401-0.521,1.277-1.546,2.069-1.578c0.457-0.361,1.05-0.736,1.619-0.736h7.424c0.568,0,1.162,0.375,1.619,0.736 c0.477,0.02,0.947,0.402,1.27,0.702c0.283,0.263,0.563,0.567,0.801,0.872c0.397,0.506,1.043,1.46,1.051,2.175 c0.265,0.482,0.538,1.095,0.527,1.629L20.08,7.91c0.241,0.12,0.404,0.343,0.404,0.685v5.669c0,0.244-0.096,0.468-0.292,0.618 c-0.005,0.004-0.011,0.008-0.017,0.013c0.518,0.133,1.119,0.313,1.414,0.79c0.213,0.345,0.199,0.739,0.07,1.111l-0.178,0.508 l-1.594-0.427L19.539,33.211z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCFCF",
    d: "M19.373,33.332c0.293,0.065,0.486,0.279,0.486,0.604v5.668c0,0.182-0.064,0.35-0.205,0.469 c-0.131,0.111-0.277,0.146-0.429,0.156l-0.011,0.495c-0.006,0.29-0.059,0.573-0.157,0.845c-0.456,1.259-1.794,2.014-2.983,2.445 c-1.537,0.558-3.314,0.775-4.944,0.777c-1.626,0.004-3.4-0.205-4.937-0.756C5,43.609,3.663,42.86,3.196,41.605 c-0.105-0.284-0.161-0.58-0.166-0.883l-0.011-0.494c-0.354-0.031-0.634-0.223-0.634-0.625v-5.669c0-0.2,0.077-0.384,0.244-0.501 c0.079-0.055,0.159-0.086,0.242-0.104L2.516,16.663l-1.649,0.442l-0.101-0.288c-0.33-0.948,0.123-1.396,0.997-1.662 C2,15.083,2.241,15.025,2.479,14.96l-0.002-0.081c-0.325-0.05-0.553-0.26-0.553-0.616V8.595c0-0.317,0.169-0.497,0.406-0.577 L2.308,6.937C2.297,6.424,2.578,5.815,2.832,5.355c-0.018-0.66,0.667-1.657,1.02-2.115c0.365-0.473,1.264-1.537,1.998-1.515 C6.281,1.379,6.869,0.99,7.41,0.99h7.424c0.543,0,1.131,0.39,1.562,0.736c0.446-0.012,0.921,0.384,1.216,0.658 c0.277,0.257,0.551,0.555,0.783,0.854c0.371,0.474,1.037,1.452,1.017,2.115c0.255,0.46,0.536,1.07,0.526,1.584l-0.023,1.082 c0.236,0.079,0.406,0.26,0.406,0.577v5.669c0,0.192-0.071,0.369-0.228,0.487c-0.104,0.079-0.212,0.114-0.326,0.128l-0.001,0.08 c0.1,0.026,0.201,0.051,0.302,0.076c0.481,0.122,1.104,0.284,1.382,0.734c0.186,0.302,0.168,0.647,0.055,0.971l-0.126,0.364 l-1.649-0.442L19.373,33.332z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C7",
    d: "M19.205,33.475c0.025,0.002,0.051,0.004,0.076,0.008c0.251,0.035,0.414,0.188,0.414,0.453v5.668 c0,0.133-0.043,0.256-0.146,0.344c-0.136,0.114-0.313,0.124-0.484,0.122l-0.014,0.651c-0.006,0.271-0.055,0.537-0.147,0.793 c-0.438,1.206-1.747,1.934-2.886,2.346c-1.519,0.551-3.277,0.766-4.888,0.768c-1.606,0.004-3.363-0.202-4.881-0.745 c-1.143-0.409-2.451-1.13-2.899-2.334c-0.1-0.267-0.151-0.544-0.156-0.827l-0.014-0.651c-0.029,0.001-0.058,0.001-0.088,0 c-0.295-0.011-0.542-0.13-0.542-0.466v-5.668c0-0.146,0.051-0.28,0.174-0.367c0.096-0.066,0.204-0.087,0.315-0.094L2.675,16.451 l-1.704,0.456l-0.05-0.144c-0.297-0.855,0.106-1.212,0.891-1.451c0.276-0.084,0.557-0.148,0.834-0.228l-0.008-0.357 c-0.029,0-0.059-0.001-0.089-0.004c-0.27-0.025-0.46-0.169-0.46-0.459V8.595c0-0.289,0.18-0.413,0.409-0.45L2.472,6.933 C2.461,6.44,2.754,5.829,2.998,5.394C2.942,4.797,3.655,3.765,3.982,3.341c0.325-0.421,1.264-1.539,1.92-1.447 c0.402-0.329,0.992-0.74,1.508-0.74h7.424c0.518,0,1.107,0.413,1.509,0.741c0.638-0.079,1.59,1.019,1.923,1.444 c0.346,0.44,1.035,1.449,0.979,2.052c0.244,0.435,0.539,1.048,0.529,1.542l-0.026,1.212c0.229,0.037,0.408,0.162,0.408,0.45v5.669 c0,0.141-0.048,0.27-0.161,0.356c-0.115,0.088-0.251,0.104-0.388,0.106L19.6,15.085c0.141,0.04,0.285,0.074,0.428,0.11 c0.428,0.108,1.035,0.26,1.283,0.661c0.158,0.258,0.135,0.555,0.039,0.831l-0.076,0.22l-1.704-0.456L19.205,33.475z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M19.037,33.637c0.166,0,0.494-0.027,0.494,0.298v5.669c0,0.357-0.402,0.299-0.627,0.299l-0.018,0.814 c-0.107,4.975-15.437,5.016-15.529,0L3.34,39.902c-0.225,0-0.627,0.059-0.627-0.299v-5.669c0-0.325,0.328-0.298,0.493-0.298 L2.835,16.237l-1.759,0.471c-0.255-0.733,0.048-1.016,0.783-1.24c0.315-0.096,0.637-0.167,0.954-0.262l-0.014-0.645 c-0.183,0-0.545,0.042-0.545-0.298V8.595c0-0.271,0.233-0.299,0.412-0.299L2.636,6.929C2.627,6.52,2.859,5.969,3.17,5.423 L3.168,5.426C3.002,4.605,5.143,1.794,5.944,2.072L5.938,2.077C6.449,1.649,6.984,1.318,7.41,1.318h7.424 c0.425,0,0.957,0.329,1.466,0.753c0.532-0.181,1.568,1.025,1.837,1.368c0.288,0.368,1.043,1.445,0.938,1.983 c0.311,0.547,0.543,1.098,0.534,1.506l-0.029,1.367c0.179,0,0.412,0.027,0.412,0.298v5.669c0,0.341-0.362,0.299-0.546,0.299 l-0.014,0.645c0.873,0.264,2.137,0.354,1.764,1.426l-0.027,0.076l-1.758-0.471L19.037,33.637z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#414142",
    d: "M17.639,38.648V32.98c0-0.165,0.135-0.299,0.299-0.299h0.594c0.164,0,0.299,0.134,0.299,0.299v5.668 c0,0.164-0.135,0.299-0.299,0.299h-0.594C17.773,38.947,17.639,38.813,17.639,38.648z M2.013,38.648V32.98 c0-0.165,0.134-0.299,0.298-0.299h0.594c0.164,0,0.298,0.134,0.298,0.299v5.668c0,0.164-0.134,0.299-0.298,0.299H2.312 C2.147,38.947,2.013,38.813,2.013,38.648z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.834,
    y1: -310.7817,
    x2: 219.834,
    y2: -316.2345,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#A6A8AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M17.747,38.649V32.98c0-0.104,0.085-0.189,0.19-0.189h0.594c0.105,0,0.19,0.085,0.19,0.189v5.669 c0,0.104-0.085,0.19-0.19,0.19h-0.594C17.832,38.84,17.747,38.754,17.747,38.649z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.209,
    y1: -310.7817,
    x2: 204.209,
    y2: -316.2344,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#A6A8AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M2.122,38.65v-5.669c0-0.104,0.085-0.19,0.19-0.19h0.594c0.104,0,0.19,0.086,0.19,0.19v5.669 c0,0.104-0.085,0.189-0.19,0.189H2.312C2.207,38.84,2.122,38.755,2.122,38.65z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#414142",
    d: "M18.1,13.309V7.64c0-0.164,0.134-0.298,0.298-0.298h0.595c0.164,0,0.299,0.134,0.299,0.298v5.669 c0,0.165-0.135,0.298-0.299,0.298h-0.595C18.233,13.607,18.1,13.473,18.1,13.309z M1.552,13.309V7.64 c0-0.164,0.134-0.298,0.299-0.298h0.594c0.164,0,0.298,0.134,0.298,0.298v5.669c0,0.165-0.134,0.298-0.298,0.298H1.851 C1.687,13.607,1.552,13.473,1.552,13.309z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.2939,
    y1: -285.4399,
    x2: 220.2939,
    y2: -290.8935,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#A6A8AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M18.207,13.309V7.64c0-0.105,0.086-0.19,0.19-0.19h0.595c0.104,0,0.189,0.085,0.189,0.19v5.668 c0,0.105-0.086,0.19-0.189,0.19h-0.595C18.293,13.499,18.207,13.414,18.207,13.309z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.748,
    y1: -285.4404,
    x2: 203.748,
    y2: -290.8931,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#A6A8AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M1.661,13.309V7.641c0-0.104,0.085-0.19,0.19-0.19h0.594c0.104,0,0.19,0.086,0.19,0.19v5.668 c0,0.105-0.086,0.19-0.19,0.19H1.851C1.746,13.5,1.661,13.414,1.661,13.309z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB0A",
    d: "M17.436,2.484c-0.305-0.39-0.68-0.798-1.079-1.092c-0.171-0.127-0.519-0.359-0.759-0.275 c0.636,0.53,1.236,1.211,1.547,1.59c0.317,0.386,0.836,1.072,1.229,1.763C18.482,3.934,17.725,2.853,17.436,2.484z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFAD6",
    d: "M17.35,2.551c-0.629-0.803-1.313-1.351-1.646-1.343c0.596,0.515,1.147,1.142,1.441,1.5 c0.289,0.354,0.749,0.958,1.125,1.587C18.23,3.909,17.885,3.233,17.35,2.551z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB0A",
    d: "M3.404,2.484c0.306-0.39,0.68-0.798,1.08-1.092c0.171-0.127,0.518-0.359,0.76-0.275 c-0.636,0.53-1.236,1.211-1.547,1.59C3.379,3.094,2.86,3.779,2.467,4.471C2.358,3.934,3.116,2.853,3.404,2.484z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFAD6",
    d: "M3.49,2.551C4.12,1.748,4.803,1.2,5.136,1.208c-0.595,0.515-1.147,1.142-1.44,1.5 C3.406,3.061,2.947,3.665,2.57,4.294C2.609,3.909,2.955,3.233,3.49,2.551z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#808184",
    d: "M2.657,39.762L1.935,5.975C1.916,5.048,3.128,3.4,3.696,2.708c0.56-0.683,2.06-2.345,3.014-2.345h7.424 c0.954,0,2.453,1.662,3.013,2.345c0.567,0.691,1.781,2.34,1.762,3.267l-0.723,33.787C18.08,44.736,2.75,44.778,2.657,39.762z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.3975,
    y1: -299.9238,
    x2: 203.6426,
    y2: -299.9238,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBDBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBBDBF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M2.765,39.76L2.043,5.972c-0.03-1.413,3.292-5.501,4.666-5.501h7.424 c1.374,0,4.696,4.088,4.665,5.501L18.078,39.76C17.975,44.59,2.855,44.631,2.765,39.76z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AC",
    d: "M14.141,1.193c0.244,0.026,0.736,0.402,0.932,0.565c0.525,0.436,1,0.949,1.433,1.476 c0.429,0.523,0.834,1.083,1.164,1.675c0.132,0.236,0.415,0.788,0.409,1.047V5.96l-0.481,6.343l-0.135-0.049 c-4.931-1.817-9.15-1.817-14.081,0l-0.135,0.049L2.765,5.959V5.957C2.76,5.696,3.043,5.145,3.174,4.908 c0.33-0.591,0.734-1.151,1.164-1.674C4.77,2.708,5.246,2.194,5.77,1.759c0.196-0.163,0.688-0.54,0.933-0.565l0.005,0h0.006 c2.472,0,4.943,0,7.415,0h0.006L14.141,1.193z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.5693,
    y1: -284.7158,
    x2: 204.4727,
    y2: -284.7158,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBDBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBBDBF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M14.129,1.301c-2.472,0-4.943,0-7.415,0C6.499,1.324,6,1.708,5.839,1.842 C5.325,2.269,4.845,2.787,4.422,3.303C4,3.816,3.592,4.38,3.269,4.961c-0.112,0.201-0.401,0.76-0.396,0.993l0.47,6.197 c4.959-1.828,9.197-1.828,14.156,0l0.47-6.197c0.005-0.232-0.284-0.792-0.396-0.993c-0.324-0.581-0.731-1.145-1.153-1.659 c-0.423-0.516-0.903-1.033-1.417-1.46C14.843,1.708,14.344,1.324,14.129,1.301z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: -53.5664,
    cy: 77.1426,
    r: 1.0008,
    gradientTransform: "matrix(9.3842 0 0 -9.3842 512.5582 745.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFB1B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808184"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M4.583,17.723c-0.308-1.894-0.616-3.267-0.923-5.161c-0.029-0.179,0.076-0.349,0.249-0.402 c4.343-1.347,8.686-1.431,13.03-0.004c0.17,0.056,0.271,0.224,0.243,0.401c-0.308,1.896-0.616,3.271-0.924,5.167 c-0.017,0.099-0.065,0.178-0.146,0.237c-0.082,0.058-0.173,0.078-0.271,0.061c-3.612-0.627-7.227-0.627-10.839,0 c-0.099,0.017-0.189-0.003-0.271-0.061C4.649,17.901,4.599,17.822,4.583,17.723z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: -57.1118,
    cy: 82.0771,
    r: 1,
    gradientTransform: "matrix(10.6216 0 0 -10.6216 616.5113 893.2031)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M4.583,17.723c-0.308-1.895-0.615-3.267-0.923-5.161c-0.017-0.104,0.012-0.205,0.073-0.282 c4.318-1.325,8.636-1.4,12.954,0.019c0.17,0.056,0.272,0.224,0.244,0.401c-0.309,1.896-0.616,3.271-0.924,5.167 c-0.01,0.061-0.032,0.113-0.066,0.158c-0.033,0.004-0.066,0.002-0.101-0.004c-3.612-0.627-7.227-0.627-10.839,0 c-0.098,0.017-0.189-0.003-0.271-0.062S4.6,17.822,4.583,17.723z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.0215,
    y1: -304.5688,
    x2: 212.0215,
    y2: -288.0276,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D2D3"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M4.537,25.014v0.197c0,2.051,0,4.104,0,6.154v0.514c0,0.481,0.011,0.962,0.017,1.443 c0.011,0.839,0.019,1.729-0.106,2.561c-0.097,0.645-0.305,1.42-0.872,1.813L3.135,38l-0.012-0.536 c-0.036-1.648-0.072-3.296-0.107-4.944l-0.002-0.078l0.038-0.068c0.11-0.199,0.285-0.343,0.48-0.459 c-0.148,0.008-0.291-0.021-0.415-0.111l-0.116-0.084l-0.003-0.143c-0.048-2.194-0.102-4.389-0.149-6.582l-0.002-0.076l0.036-0.066 c0.08-0.148,0.221-0.208,0.388-0.215c-0.227-0.113-0.404-0.275-0.433-0.537l-0.001-0.012l0-0.012 c-0.069-3.177-0.142-6.354-0.211-9.53L2.61,13.833l0.507,0.502c0.471,0.466,0.768,1.555,0.914,2.183 c0.313,1.354,0.45,2.808,0.506,4.195l0,0.006v0.005c0,1.31,0,2.618,0,3.927L4.537,25.014L4.537,25.014z M17.572,24.637 c0.166,0.008,0.309,0.066,0.387,0.215l0.036,0.066l-0.002,0.076c-0.047,2.194-0.102,4.389-0.149,6.582l-0.003,0.143l-0.116,0.084 c-0.123,0.091-0.266,0.119-0.414,0.111c0.195,0.117,0.37,0.26,0.48,0.459l0.038,0.068l-0.003,0.078 c-0.035,1.648-0.07,3.297-0.106,4.944L17.708,38l-0.44-0.305c-0.568-0.393-0.775-1.168-0.873-1.813 c-0.125-0.831-0.117-1.722-0.105-2.561c0.006-0.481,0.018-0.962,0.018-1.443v-0.514c0-2.051,0-4.104,0-6.154V24.65 c0-1.309,0-2.617,0-3.926v-0.006v-0.006c0.056-1.387,0.192-2.84,0.506-4.195c0.145-0.628,0.442-1.717,0.913-2.183l0.507-0.502 l-0.016,0.713c-0.068,3.177-0.143,6.354-0.211,9.53v0.012l-0.002,0.013C17.977,24.362,17.799,24.523,17.572,24.637z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.625,
    y1: -306.2632,
    x2: 204.9591,
    y2: -306.2632,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41403B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8B83"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M3.288,31.57c-0.05-2.297-0.1-4.285-0.149-6.582c0.109-0.205,0.841,0.117,1.11,0.223 c0,2.051,0,4.104,0,6.154C3.975,31.498,3.514,31.735,3.288,31.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.7041,
    y1: -312.6572,
    x2: 205.0917,
    y2: -312.6572,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808184"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M3.412,37.457c-0.036-1.648-0.071-3.296-0.107-4.943c0.175-0.316,0.676-0.504,0.944-0.635 C4.248,34.027,4.483,36.715,3.412,37.457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.082,
    y1: -306.2632,
    x2: 218.4164,
    y2: -306.2632,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41403B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8B83"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M17.555,31.57c0.051-2.297,0.1-4.285,0.15-6.582c-0.109-0.205-0.842,0.117-1.11,0.223 c0,2.051,0,4.104,0,6.154C16.868,31.498,17.328,31.735,17.555,31.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.9443,
    y1: -312.6572,
    x2: 218.3648,
    y2: -312.6572,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41403B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8B83"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M17.432,37.457c0.035-1.648,0.071-3.296,0.107-4.943c-0.176-0.316-0.676-0.504-0.944-0.635 C16.595,34.027,16.359,36.715,17.432,37.457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.2627,
    y1: -297.5845,
    x2: 218.4623,
    y2: -297.5845,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41403B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8B83"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M17.717,24.07c0.07-3.248,0.142-6.282,0.212-9.53c-0.585,0.578-1.197,2.806-1.334,6.184 c0,1.31,0,2.618,0,3.927C16.922,24.537,17.679,24.436,17.717,24.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.5811,
    y1: -297.5845,
    x2: 204.7806,
    y2: -297.5845,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41403B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8B83"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M3.125,24.07c-0.07-3.248-0.141-6.282-0.211-9.53c0.584,0.578,1.197,2.806,1.334,6.184 c0,1.31,0,2.618,0,3.927C3.92,24.537,3.165,24.436,3.125,24.07z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    d: "M4.237,41.029c-0.268-0.249-0.298-0.646-0.242-0.988c0.063-0.392,0.242-0.791,0.463-1.117 c0.084-0.123,0.178-0.241,0.28-0.35l0.288-0.307l0.183,0.379c0.24,0.496,1.288,0.807,1.774,0.928c1.092,0.271,2.308,0.37,3.43,0.377 c1.124-0.007,2.339-0.105,3.431-0.377c0.486-0.12,1.535-0.432,1.774-0.928l0.183-0.379l0.287,0.307 c0.104,0.108,0.196,0.227,0.28,0.35c0.222,0.326,0.401,0.726,0.464,1.117c0.055,0.342,0.025,0.739-0.242,0.988 c-0.566,0.746-1.617,1.178-2.49,1.424c-1.172,0.33-2.463,0.459-3.679,0.46h-0.016c-1.215-0.001-2.505-0.131-3.677-0.46 C5.855,42.207,4.804,41.775,4.237,41.029z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: -45.9634,
    cy: 66.5596,
    r: 0.9997,
    gradientTransform: "matrix(7.5085 0 0 -7.5085 355.4071 536.6236)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M10.414,40.24c-2.506-0.016-5.007-0.523-5.464-1.469c-0.609,0.646-0.914,1.713-0.499,2.061 c0.879,1.192,3.416,1.789,5.955,1.793h0.008h0.007c2.54-0.004,5.075-0.601,5.956-1.793c0.414-0.348,0.109-1.414-0.499-2.061 C15.421,39.717,12.92,40.225,10.414,40.24z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AC",
    d: "M0.349,15.678c-0.078-0.225-0.109-0.472,0.018-0.686c0.157-0.265,0.512-0.393,0.792-0.478 c0.377-0.115,0.763-0.193,1.138-0.321c0.136-0.046,0.27-0.099,0.399-0.161l0.094-0.045l0.027,0.101 c0.077,0.287,0.154,0.575,0.23,0.862l0.022,0.083l-0.083,0.022c-0.844,0.227-1.688,0.453-2.533,0.679l-0.078,0.021L0.349,15.678z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M0.431,15.65c-0.399-1.146,1.171-0.995,2.302-1.54c0.077,0.287,0.154,0.575,0.231,0.861 C2.12,15.198,1.275,15.424,0.431,15.65z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AC",
    d: "M2.823,15.099l-0.274-1.022l-0.346,0.093l0.274,1.022L2.823,15.099z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D2D3",
    d: "M2.718,15.038l-0.229-0.855L2.31,14.231l0.229,0.855L2.718,15.038z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AC",
    d: "M20.494,15.678c0.078-0.225,0.108-0.472-0.019-0.686c-0.157-0.265-0.511-0.393-0.791-0.478 c-0.378-0.115-0.763-0.193-1.138-0.321c-0.137-0.046-0.27-0.099-0.398-0.161l-0.095-0.045l-0.026,0.101 c-0.078,0.287-0.154,0.575-0.231,0.862l-0.022,0.083l0.084,0.022c0.844,0.227,1.688,0.453,2.533,0.679l0.076,0.021L20.494,15.678z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M20.412,15.65c0.398-1.146-1.171-0.995-2.302-1.54c-0.077,0.287-0.153,0.575-0.231,0.861 C18.724,15.198,19.568,15.424,20.412,15.65z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AC",
    d: "M18.367,15.19l0.273-1.022l-0.346-0.092l-0.273,1.022L18.367,15.19z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D2D3",
    d: "M18.303,15.086l0.23-0.855l-0.18-0.048l-0.229,0.854L18.303,15.086z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M2.677,23.586c-0.002-0.143-0.034-0.742,0.095-0.742h0.119l0.022,1.137 C2.753,23.996,2.68,23.774,2.677,23.586z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.3994,
    y1: -301.9233,
    x2: 204.381,
    y2: -300.8662,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D2D3"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M2.88,23.926c-0.134,0.014-0.169-0.24-0.17-0.34c-0.002-0.141-0.022-0.699,0.063-0.699 c0.02,0,0.036,0,0.086,0C2.867,23.238,2.874,23.575,2.88,23.926z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M2.825,31.123c-0.002-0.143-0.034-0.742,0.096-0.742h0.119l0.022,1.137 C2.9,31.533,2.827,31.313,2.825,31.123z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.5469,
    y1: -309.4614,
    x2: 204.5284,
    y2: -308.405,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D2D3"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M3.028,31.465c-0.135,0.014-0.169-0.24-0.17-0.34c-0.002-0.142-0.022-0.699,0.063-0.699 c0.02,0,0.036,0,0.086,0C3.015,30.776,3.021,31.114,3.028,31.465z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M18.166,23.585c0.001-0.143,0.033-0.742-0.096-0.742h-0.119l-0.021,1.136 C18.09,23.996,18.163,23.773,18.166,23.585z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.6641,
    y1: -300.8662,
    x2: 219.6457,
    y2: -301.9242,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D2D3"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M17.962,23.927c0.135,0.013,0.169-0.24,0.171-0.341c0.002-0.141,0.021-0.699-0.064-0.699 c-0.02,0-0.036,0-0.086,0C17.976,23.238,17.969,23.576,17.962,23.927z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M18.018,31.124c0.002-0.144,0.034-0.742-0.095-0.742h-0.118l-0.023,1.136 C17.942,31.534,18.016,31.313,18.018,31.124z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.5166,
    y1: -308.4063,
    x2: 219.4982,
    y2: -309.4644,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D2D3"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M17.815,31.465c0.134,0.014,0.169-0.239,0.171-0.34c0.002-0.141,0.021-0.699-0.064-0.699 c-0.02,0-0.036,0-0.086,0C17.829,30.777,17.822,31.115,17.815,31.465z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.7998,
    y1: -307.0776,
    x2: 206.2422,
    y2: -307.0776,
    gradientTransform: "matrix(1 0 0 -1 -201.5996 -277.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBDBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBBDBF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M4.88,38.485c-0.079-6.626,0.052-16.859-0.237-20.086c3.821-0.708,7.737-0.708,11.558,0 c-0.29,3.227-0.158,13.46-0.237,20.086C15.982,40.916,4.861,40.916,4.88,38.485z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M5.516,37.573c0.09-5.265-0.057-10.53-0.463-15.778c-0.009-0.121,0.02-0.236,0.112-0.317 c0.139-0.122,0.339-0.108,0.51-0.108c0.222,0,0.424,0.187,0.416,0.42C5.885,27.05,6.084,32.324,6.553,37.564 c0.011,0.119-0.016,0.233-0.106,0.314c-0.139,0.125-0.343,0.111-0.515,0.111c-0.223,0-0.409-0.186-0.416-0.412v-0.003V37.573z  M15.326,37.578c-0.006,0.228-0.192,0.412-0.415,0.412c-0.081,0-0.157,0.004-0.238-0.004c-0.239-0.025-0.407-0.154-0.384-0.422 c0.469-5.24,0.669-10.515,0.464-15.774c-0.009-0.233,0.193-0.42,0.415-0.42c0.08,0,0.158-0.004,0.238,0.004 c0.237,0.025,0.404,0.154,0.384,0.42c-0.406,5.248-0.554,10.514-0.463,15.778v0.002L15.326,37.578z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M5.625,37.58c0.09-5.178-0.057-10.354-0.463-15.531c-0.026-0.336,0.34-0.3,0.514-0.3 c0.164,0,0.314,0.136,0.307,0.3C5.78,27.131,5.967,32.316,6.446,37.58c0.03,0.336-0.341,0.3-0.514,0.3 C5.768,37.88,5.629,37.744,5.625,37.58z M15.219,37.58c-0.091-5.178,0.057-10.354,0.463-15.531c0.027-0.336-0.34-0.3-0.514-0.3 c-0.164,0-0.313,0.136-0.307,0.3c0.201,5.082,0.015,10.268-0.463,15.531c-0.031,0.336,0.34,0.3,0.513,0.3 C15.075,37.88,15.213,37.744,15.219,37.58z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    d: "M6.608,2.716c0.184,1.144,0.354,2.477,0.489,3.9s0.218,2.757,0.25,3.9c-0.184-1.144-0.353-2.477-0.488-3.9 S6.641,3.86,6.608,2.716z M14.234,2.716c-0.184,1.144-0.354,2.477-0.488,3.9s-0.218,2.757-0.25,3.9 c0.184-1.144,0.352-2.477,0.487-3.9C14.118,5.193,14.201,3.86,14.234,2.716z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF800",
    stroke: "#000000",
    strokeMiterlimit: 10,
    cx: 10.422,
    cy: 29.088,
    r: 6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    points: "10.422,24.465 10.422,29.088 14.269,30.909 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayed);
export default __webpack_public_path__ + "static/media/delayed.1af06c1f16385f9107ec73928e6a6e40.svg";
export { ForwardRef as ReactComponent };